import { ItineraryStop, ZoneGeometryDto } from '../graphql/types';
import * as turf from '@turf/turf';

export const transformZonesToFeatureCollection = (
  data: ZoneGeometryDto[],
  stops: ItineraryStop[],
) => {
  const geoJsonFeatures = data.flatMap((zone) => {
    const polygons = JSON.parse(
      zone.polygonsGeoJson,
    ) as GeoJSON.FeatureCollection<GeoJSON.Polygon>;

    return polygons.features.map((feature) => {
      // Check if any marker is inside this polygon
      const containsMarker = stops
        ?.filter((stop) => stop.latitude && stop.longitude)
        .some((stop) => {
          const point = turf.point([
            stop.longitude as number,
            stop.latitude as number,
          ]);
          return turf.booleanPointInPolygon(point, feature);
        });

      return {
        ...feature,
        properties: {
          ...feature.properties,
          zoneCode: zone.zoneCode,
          containsMarker,
        },
      };
    });
  });

  return {
    type: 'FeatureCollection',
    features: geoJsonFeatures,
  } as GeoJSON.FeatureCollection<GeoJSON.Geometry>;
};
